export default __webpack_public_path__ + "static/media/peter.46a55709.jpeg";